import React from 'react';
import { AnimatedFooter } from './ui/AnimatedFooter';
import { COMPANY, LEGAL_LINKS } from '../data/company';
export function Footer() {
  return <AnimatedFooter leftLinks={LEGAL_LINKS.map(link => ({
    href: link.href,
    label: link.label
  }))} rightLinks={[{
    href: '/',
    label: 'Inicio'
  }, {
    href: '/servicios',
    label: 'Servicios'
  }, {
    href: '/proceso',
    label: 'Proceso'
  }, {
    href: '/resultados',
    label: 'Enfoque'
  }, {
    href: '/faq',
    label: 'FAQ'
  }, {
    href: '/contacto',
    label: 'Contacto'
  }]} copyrightText={`© ${new Date().getFullYear()} ${COMPANY.legalName}. Todos los derechos reservados.`} barCount={23} data-id="element-40" data-mp="3ggk7utmc79z0" />;
}